import { actions as actions$1 } from '@grandvisionhq/state';

const updateActiveVariant = actions$1.action('UPDATE_ACTIVE_VARIANT', actions$1.payload());

export { updateActiveVariant };
//# sourceMappingURL=actions.js.map
